module.exports = __webpack_public_path__ + "static/media/C_10.30f827f1.png";